import type { DSFormLayoutProps } from "@/src/design_system/layouts_and_containers/form_layout/types";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_FORM_LAYOUT_CLASSES = {
  Root: "ds-form-layout",
  Content: "ds-form-layout__content",
  Footer: "ds-form-layout__footer",
} as const;

export const DS_FORM_LAYOUT_SIZE_CLASS: Record<NonNullable<DSFormLayoutProps["size"]>, string> = {
  [DS_SIZE.Small]: "ds-form-layout--sm",
  [DS_SIZE.Medium]: "ds-form-layout--md",
  [DS_SIZE.Large]: "ds-form-layout--lg",
} as const;
